import { makeStyles } from '@material-ui/core/styles';
import { red, green,blue } from '@material-ui/core/colors';

export default makeStyles((theme) => ({
  footer: {

  },
  footerText:{
    fontSize:12,
  }
}));
